/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { addClientNotice } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';
import connect from 'react-redux/es/connect/connect';
import formatBytes from '../../../utils/formatBytes';

// eslint-disable-next-line react/prefer-stateless-function
class PromotionalMaterialsFromUserListItem extends Component {
  constructor(props) {
    super(props);
    const domain = document.location.origin;
    const urlParam = `?ref=${props.authUserId}`;
    this.state = {
      domain,
      urlParam,
      referralUrl: `${domain}/${urlParam}`
    };
  }

  render() {
    return (
      <div className="col-sm-12 col-xs-24">
        <article className="panel panel-default">
          <div className="panel-thumbnail">
            <div className="thumbnail thumbnail_collapsed">
              <div className="thumbnail_collapsed-img">
                <div className="thumbnail_collapsed-img-wrapper">
                  <img
                    src={this.props.item.fileUrl}
                    alt={this.props.item.title}
                  />
                </div>
                <div className="caption">
                  <p className="text-center text-caption">
                    <i className="fa fa-expand" />{' '}
                    {this.props.item.imgResolution},{' '}
                    <i className="fa fa-file-o" />{' '}
                    {formatBytes(this.props.item.imgFileSize)}
                  </p>
                </div>
              </div>
              <div className="thumbnail_collapsed-description">
                <div className="form-group">
                  <label className="control-label sr-only" htmlFor={'none'}>
                    Код баннера
                  </label>
                  <textarea
                    readOnly="readonly"
                    name="widgetCode"
                    className="form-control"
                    value={`<noindex><a rel="nofollow" target="_blank" href="${this.state.referralUrl}"><img src="${this.props.item.fileUrl}" alt="${this.props.item.title}"/></a></noindex>`}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="panel-footer text-center">
            <div className="row">
              <div className="col-xs-12">
                <a href="" data-toggle="thumbnail-collapsed">
                  <i className="fa fa-code" /> html-код
                </a>
              </div>
              <div className="col-xs-12">
                <a
                  href={this.props.item.fileUrl}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <i className="fa fa-external-link" /> Открыть
                </a>
              </div>
            </div>
          </div>
        </article>
      </div>
    );
  }
}

PromotionalMaterialsFromUserListItem.propTypes = {
  // IN
  item: PropTypes.shape({
    title: PropTypes.string.isRequired,
    imgResolution: PropTypes.string.isRequired,
    imgFileSize: PropTypes.number.isRequired,
    fileUrl: PropTypes.string.isRequired
  }).isRequired,

  // CONNECT
  authUserId: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  authUserId: selectUserId(state)
});

const mapDispatchToProps = dispatch => ({
  addClientNotice: params => dispatch(addClientNotice(params))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PromotionalMaterialsFromUserListItem);



// WEBPACK FOOTER //
// ./src/components/PromotionalMaterials/PromotionalMaterialsListFromUser/PromotionalMaterialsFromUserListItem.js